import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a9674c67084a279faae87cf583c4b766bb from "./generated-b2197af2-91ea-4314-8839-11cb6d67c027.json";

import aed9247d76ab69b85845922495cc6bcf4b from "./generated-73deefd5-dc57-40db-a5c0-b115ee86518f.json";

import a613bfb0961ae60c84f8b3ebf6f5ea3dcb from "./generated-2eb56277-3b2e-487c-b8a5-f3a25b376d07.json";

import ae2f43ef8384c350b04de334d42bbb675b from "./generated-73dff12c-5220-4054-9138-288ece8d3b69.json";

import a0dd6cf1919b84f8dab0aceaada5871e7b from "./generated-5fdac428-8f05-4a63-aa4f-02b0b1d54f50.json";

import a34763c835787c984a5b4ed1fc32fb1ccb from "./generated-21df8a8b-bfb3-41e4-9bde-f9df4437b1eb.json";

import a6c0b4396986c36da856ce9209e4f28fdb from "./generated-c02bd89b-d2b4-49be-b30a-caf952ab61dd.json";

import ad02e76c9bbe6b0a35bbb328c9bae3e15b from "./generated-152f0e44-a141-4ba2-9475-df3aca705731.json";

import af3380400dd4c5c24e1fd5110c52d5d6fb from "./generated-417b26cb-c418-4694-93d9-f9304052bb8d.json";

import a930f6563d92c2c22ae4821c4636b3967b from "./generated-977479b1-6b27-407e-ab64-2c0d2080a1fd.json";

import a42da6588d95a5fba7ed2a0a9e7df3e6ab from "./generated-e8f3af6c-975b-415d-8e37-734a3ce2749f.json";

import add3d660fd0eb76daf342330117723576b from "./generated-07441b61-a466-43d3-9454-b794c8ea75e9.json";

import aee818da1c464f6b177e1b801326e49b1b from "./generated-507e5471-8c79-49ea-8967-e53a78356b44.json";

import aa40e28e62790df6bae7dde62087dd127b from "./generated-d8d9dcf5-7fb6-470d-b249-6d1111a20c46.json";

import aed1bb7cc6a30cd88b7d8186419ce965eb from "./generated-e5d6f5ff-5d68-4bde-a031-a29e70b9af40.json";

import a4c930b4996acb4c04692034edb991af5b from "./generated-774bb654-8cde-4ca8-b1fd-d235f7b5e84b.json";

import a3298976c67e07f3c217b9bb9a1d67428b from "./generated-eccb1558-bc53-4201-b477-414c67cacbc6.json";

import a4a4c3c9832facc662cba6bf01b23432eb from "./generated-a2e4c6cd-afc9-43e4-9afa-bb2c439a0a75.json";

import ad0141c3ac91ff0489863895b4b4b4fedb from "./generated-ab844e2e-55eb-4693-ab6a-aeb4cee1f675.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a9674c67084a279faae87cf583c4b766bb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aed9247d76ab69b85845922495cc6bcf4b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a613bfb0961ae60c84f8b3ebf6f5ea3dcb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ae2f43ef8384c350b04de334d42bbb675b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a0dd6cf1919b84f8dab0aceaada5871e7b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a34763c835787c984a5b4ed1fc32fb1ccb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a6c0b4396986c36da856ce9209e4f28fdb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ad02e76c9bbe6b0a35bbb328c9bae3e15b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(af3380400dd4c5c24e1fd5110c52d5d6fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a930f6563d92c2c22ae4821c4636b3967b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a42da6588d95a5fba7ed2a0a9e7df3e6ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(add3d660fd0eb76daf342330117723576b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aee818da1c464f6b177e1b801326e49b1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aa40e28e62790df6bae7dde62087dd127b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aed1bb7cc6a30cd88b7d8186419ce965eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a4c930b4996acb4c04692034edb991af5b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a3298976c67e07f3c217b9bb9a1d67428b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a4a4c3c9832facc662cba6bf01b23432eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ad0141c3ac91ff0489863895b4b4b4fedb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a3298976c67e07f3c217b9bb9a1d67428b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */